export const DEFAULT_OPTIONS = {
  height: '444',
  width: '801',
  playerVars: {
    autoplay: 1,
    enablejsapi: 1,
  },
};
